import React, { Component } from 'react';
import PropTypes from 'prop-types';
import BlockButton from '../Utilities/BlockButton';
export default class CarouselIndicator extends Component {
    constructor() {
        super(...arguments);
        this.onSlideClick = () => {
            console.log('slide clicked');
            this.props.goToSlide(this.props.slideNumber);
        };
    }
    render() {
        const { active, offset } = this.props;
        return (React.createElement(BlockButton, { as: 'li', style: Object.assign(Object.assign({}, offset), { textIndent: '0', overflow: 'hidden' }), className: active ? 'active' : '', onClick: this.onSlideClick }, this.props.children));
    }
}
CarouselIndicator.propTypes = {
    active: PropTypes.bool,
    children: PropTypes.node,
    goToSlide: PropTypes.func,
    slideNumber: PropTypes.number,
    offset: PropTypes.objectOf(PropTypes.number),
};
